function nonemptyString(value: unknown): string | null {
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

export function getErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error) {
    return nonemptyString(error.message) ?? fallback;
  }

  if (error && typeof error === "object") {
    const payload = error as Record<string, unknown>;
    return (
      nonemptyString(payload.message) ??
      nonemptyString(payload.error) ??
      fallback
    );
  }

  return fallback;
}
